// extracted by mini-css-extract-plugin
module.exports = {"Li":"privacy_Li__1asgc"};